import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { PRESTAZIONI } from "@/data/siteData";
import { HOME } from "@/constants/testIds";

export default function Prestazioni() {
  return (
    <section id="prestazioni" className="relative py-24 md:py-32 bg-[#EEF5F9]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-2xl">
            <p className="overline">Prestazioni</p>
            <h2 className="font-serif text-4xl md:text-5xl mt-4 text-[#0B4A5A] tracking-tight">
              Servizi diagnostici e terapeutici completi.
            </h2>
          </div>
          <p className="text-gray-600 md:max-w-sm leading-relaxed">
            Strumentazione di ultima generazione e ambienti confortevoli per un
            percorso di cura sereno.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {PRESTAZIONI.map((s) => {
            const Icon = Icons[s.icon] || Icons.Stethoscope;
            return (
              <Link
                to={`/prestazioni/${s.slug}`}
                key={s.slug}
                data-testid={HOME.prestazioneCard(s.slug)}
                className="service-card group bg-white rounded-2xl border border-gray-100 p-8 flex flex-col justify-between min-h-[240px]"
              >
                <div>
                  <div className="icon-halo">
                    <Icon size={22} strokeWidth={1.4} />
                  </div>
                  <h3 className="font-serif text-2xl mt-5 text-[#0B4A5A]">
                    {s.name}
                  </h3>
                  <p className="text-[13px] uppercase tracking-[0.14em] text-[#C6A86B] mt-2">
                    {s.duration}
                  </p>
                  <p className="mt-4 text-gray-600 leading-relaxed text-[15px]">
                    {s.desc}
                  </p>
                </div>
                <div className="flex items-center gap-2 mt-6 text-[#0B4A5A] font-medium text-sm">
                  Scopri di più
                  <Icons.ArrowRight
                    size={16}
                    strokeWidth={1.5}
                    className="transition-transform group-hover:translate-x-1"
                  />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
